import { render, staticRenderFns } from "./selectgroup.vue?vue&type=template&id=01889f12"
import script from "./selectgroup.vue?vue&type=script&lang=js"
export * from "./selectgroup.vue?vue&type=script&lang=js"
import style0 from "./selectgroup.vue?vue&type=style&index=0&id=01889f12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports